import { EverifyUserRole, MyI9TrainingStatus, User, UserStatus, UserTypeEnum } from '@vis-auth/vis-user-client';

export const generalUser: User = {
  id: '1',
  firstName: 'Mock General User',
  lastName: 'no Web Service',
  email: 'mock@email.com',
  phoneNumber: {
    number: '111-222-3333',
  },
  logonId: 'MOCK1111',
  accountId: '111111',
  personId: '111111',
  roles: [EverifyUserRole.GENERAL],
  status: UserStatus.ACTIVE,
  userType: UserTypeEnum.EVERIFY,
  webServiceEnabled: false,
  tutorialComplete: true,
  createdDate: new Date(),
  myI9TrainingStatus: MyI9TrainingStatus.COMPLETE,
  mfaEnabled: false,
};

export const generalUserWithWebService: User = {
  id: '2',
  firstName: 'Mock General User',
  lastName: 'with Web Service',
  email: 'mock@email.com',
  phoneNumber: {
    number: '111-222-3333',
  },
  logonId: 'MOCK2222',
  accountId: '222222',
  personId: '222222',
  roles: [EverifyUserRole.GENERAL],
  status: UserStatus.ACTIVE,
  userType: UserTypeEnum.EVERIFY,
  webServiceEnabled: false,
  tutorialComplete: true,
  createdDate: new Date(),
  myI9TrainingStatus: MyI9TrainingStatus.COMPLETE,
  mfaEnabled: false,
};
export const generalUserNoTutorial: User = {
  id: '3',
  firstName: 'Mock General User',
  lastName: 'Tuorial Not Completed',
  email: 'mock@email.com',
  phoneNumber: {
    number: '111-222-3333',
  },
  logonId: 'MOCK3333',
  accountId: '333333',
  personId: '333333',
  roles: [EverifyUserRole.GENERAL],
  status: UserStatus.ACTIVE,
  userType: UserTypeEnum.EVERIFY,
  webServiceEnabled: false,
  tutorialComplete: false,
  createdDate: new Date(),
  myI9TrainingStatus: MyI9TrainingStatus.COMPLETE,
  mfaEnabled: false,
};

export const programAdmin: User = {
  id: '4',
  firstName: 'Mock Program Admin',
  lastName: 'Tuorial Not Completed',
  email: 'mock@email.com',
  phoneNumber: {
    number: '111-222-3333',
  },
  logonId: 'MOCK3333',
  accountId: '333333',
  personId: '333333',
  roles: [EverifyUserRole.PROGRAMADMIN],
  status: UserStatus.ACTIVE,
  userType: UserTypeEnum.EVERIFY,
  webServiceEnabled: false,
  tutorialComplete: false,
  createdDate: new Date(),
  myI9TrainingStatus: MyI9TrainingStatus.COMPLETE,
  mfaEnabled: false,
};

export const corporateAdmin: User = {
  id: '5',
  firstName: 'Mock Corporate Admin',
  lastName: 'Tuorial Not Completed',
  email: 'mock@email.com',
  phoneNumber: {
    number: '111-222-3333',
  },
  logonId: 'MOCK3333',
  accountId: '333333',
  personId: '333333',
  roles: [EverifyUserRole.CORPORATEADMIN],
  status: UserStatus.ACTIVE,
  userType: UserTypeEnum.EVERIFY,
  webServiceEnabled: false,
  tutorialComplete: false,
  createdDate: new Date(),
  myI9TrainingStatus: MyI9TrainingStatus.COMPLETE,
  mfaEnabled: false,
};

export const enrollmentUser: User = {
  id: '6',
  firstName: 'Mock Enrollment User',
  lastName: 'Tuorial Not Completed',
  email: 'mock@email.com',
  phoneNumber: {
    number: '111-222-3333',
  },
  logonId: 'MOCK3333',
  accountId: '333333',
  personId: '333333',
  roles: [EverifyUserRole.ENROLLMENT],
  status: UserStatus.ACTIVE,
  userType: UserTypeEnum.EVERIFY,
  webServiceEnabled: false,
  tutorialComplete: false,
  createdDate: new Date(),
  myI9TrainingStatus: MyI9TrainingStatus.NOTCOMPLETE,
  mfaEnabled: false,
};

export const generalUserWithMyI9TrainingComplete: User = {
  id: '7',
  firstName: 'Mock General User',
  lastName: 'no Web Service',
  email: 'mock@email.com',
  phoneNumber: {
    number: '111-222-3333',
  },
  logonId: 'MOCK1111',
  accountId: '111111',
  personId: '111111',
  roles: [EverifyUserRole.GENERAL],
  status: UserStatus.ACTIVE,
  userType: UserTypeEnum.EVERIFY,
  webServiceEnabled: false,
  tutorialComplete: true,
  createdDate: new Date(),
  myI9TrainingStatus: MyI9TrainingStatus.COMPLETE,
  mfaEnabled: false,
};

export const generalUserWithMyI9TrainingNotComplete: User = {
  id: '8',
  firstName: 'Mock General User',
  lastName: 'no Web Service',
  email: 'mock@email.com',
  phoneNumber: {
    number: '111-222-3333',
  },
  logonId: 'MOCK1111',
  accountId: '111111',
  personId: '111111',
  roles: [EverifyUserRole.GENERAL],
  status: UserStatus.ACTIVE,
  userType: UserTypeEnum.EVERIFY,
  webServiceEnabled: false,
  tutorialComplete: true,
  createdDate: new Date(),
  myI9TrainingStatus: MyI9TrainingStatus.NOTCOMPLETE,
  mfaEnabled: false,
};

export const generalUserWithMFAEnabled: User = {
  id: '1',
  firstName: 'Mock General User',
  lastName: 'no Web Service',
  email: 'mock@email.com',
  phoneNumber: {
    number: '111-222-3333',
  },
  logonId: 'MOCK1111',
  accountId: '111111',
  personId: '111111',
  roles: [EverifyUserRole.GENERAL],
  status: UserStatus.ACTIVE,
  userType: UserTypeEnum.EVERIFY,
  webServiceEnabled: false,
  tutorialComplete: true,
  createdDate: new Date(),
  myI9TrainingStatus: MyI9TrainingStatus.COMPLETE,
  mfaEnabled: true,
};

export const generalUserWithWebServicesAccess: User = {
  id: '10',
  firstName: 'Mock General User',
  lastName: 'with Web Service',
  email: 'mock@email.com',
  phoneNumber: {
    number: '111-222-3333',
  },
  logonId: 'MOCK1111',
  accountId: '111111',
  personId: '111111',
  roles: [EverifyUserRole.GENERAL],
  status: UserStatus.ACTIVE,
  userType: UserTypeEnum.EVERIFY,
  webServiceEnabled: true,
  tutorialComplete: true,
  createdDate: new Date(),
  myI9TrainingStatus: MyI9TrainingStatus.COMPLETE,
  mfaEnabled: false,
};
